export function updatePollyPlayerSkipButton(showPollyPlayerSkipButton) {
  return {
    type: 'UPDATE_POLLY_PLAYER_SKIP_BUTTON',
    showPollyPlayerSkipButton
  };
}

export function resetPlayer() {
  return {
    type: 'RESET_PLAYER'
  };
}

export function setPlayResource(resource) {
  return {
    type: 'SET_PLAY_RESOURCE',
    payload: resource
  };
}

export function setPlayerDocument(playerDocument) {
  return {
    type: 'SET_PLAYER_DOCUMENT',
    payload: playerDocument
  };
}

export function setDisableSkipBackButton(value) {
  return {
    type: 'SET_DISABLE_SKIP_BACK_BUTTON',
    payload: value
  };
}

export function setDisableSkipAheadButton(value) {
  return {
    type: 'SET_DISABLE_SKIP_AHEAD_BUTTON',
    payload: value
  };
}

export function setShowSkipButton(value) {
  return {
    type: 'SET_SHOW_SKIP_BUTTON',
    payload: value
  };
}

export function setPressForwardButton(value) {
  return {
    type: 'SET_PRESS_FORWARD_BUTTON',
    payload: value
  };
}

export function setPressBackwardButton(value) {
  return {
    type: 'SET_PRESS_BACKWARD_BUTTON',
    payload: value
  };
}

export function setFlagAdded(value) {
  return {
    type: 'SET_FLAG_ADDED',
    payload: value
  };
}

export function setIsPaused(value) {
  return {
    type: 'SET_IS_PAUSED',
    payload: value
  };
}

export function resetProgress(value) {
  return {
    type: 'RESET_PROGRESS',
    payload: value
  };
}

export function setAllDocuments(value) {
  return {
    type: 'SET_ALL_DOCUMENTS',
    payload: value
  };
}

export function setFullSerialDocuments(value) {
  return {
    type: 'SET_FULL_SERIAL_DOCUMENTS',
    payload: value
  };
}

export function setAllSeasons(value) {
  return {
    type: 'SET_ALL_SEASONS',
    payload: value
  };
}

export function setFromPlaylistTab(value) {
  return {
    type: 'SET_FROM_PLAYLIST_TAB',
    payload: value
  };
}

export function setStoreProgress(value) {
  return {
    type: 'SET_STORE_PROGRESS',
    payload: value
  };
}

export function setFeedUrl(value) {
  return {
    type: 'SET_FEED_URL',
    payload: value
  };
}

export function setNewDocumentInLast5(value) {
  return {
    type: 'SET_NEW_DOCUMENT_IN_LAST_5',
    payload: value
  };
}

export function setSeason(value) {
  return {
    type: 'SET_SEASON',
    payload: value
  };
}

export function setFromSkip(value) {
  return {
    type: 'SET_FROM_SKIP',
    payload: value
  };
}

export function setPodcastSeasons(value) {
  return {
    type: 'SET_PODCAST_SEASONS',
    payload: value
  };
}

export function setOnPlaylist(value) {
  return {
    type: 'SET_ON_PLAYLIST',
    payload: value
  };
}

export function sameProgress(value) {
  return {
    type: 'SAME_PROGRESS',
    payload: value
  };
}

//player flags
export function setPlayerFlag(playerFlag) {
  return {
    type: 'SET_PLAYER_FLAG',
    payload: playerFlag
  };
}

export function setIsSelectedFlags(value) {
  return {
    type: 'SET_IS_SELECTED_FLAGS',
    payload: value
  };
}

export function setTimeProgress(value) {
  return {
    type: 'SET_TIME_PROGRESS',
    payload: value
  };
}
